export const BiddingScheme = {
  EnhancedCpc: 'EnhancedCpc',
  MaxConversions: 'MaxConversions',
  ManualCpm: 'ManualCpm',
  ManualCpv: 'ManualCpv',
};
